// -----------------------------------------------------------------------------
// useHistory — Écoute temps réel de l'historique des mouvements
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { useState, useEffect } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
} from "firebase/firestore";

import { db, HISTORY_COL } from "../firebase";

/**
 * Écoute en temps réel l'historique des mouvements de stock d'un restaurant.
 * Triés du plus récent au plus ancien.
 *
 * @param {string|null} restaurantId - ID du restaurant
 * @returns {{ historyLogs: Array, error: Error|null }}
 */
export function useHistory(restaurantId) {
  const [historyLogs, setHistoryLogs] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!restaurantId) {
      setHistoryLogs([]);
      setError(null);
      return;
    }

    const q = query(
      collection(db, HISTORY_COL),
      where("restaurantId", "==", restaurantId),
      orderBy("createdAt", "desc")
    );

    const unsub = onSnapshot(
      q,
      (snapshot) => {
        setHistoryLogs(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
        setError(null);
      },
      (err) => {
        console.error("Firestore history error:", err);
        setError(err);
      }
    );

    return unsub;
  }, [restaurantId]);

  return { historyLogs, error };
}
